// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './screens/home/Home';
import Product from './screens/products/Product';
import Contact from './screens/contact/Contact';
import Knowledge from './screens/knowledge/Knowledge';
import PostDetail from './screens/detail/PostDetail';

const App = () => {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Home />} />
        <Route path="/products" element={<Product />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/knowledge" element={<Knowledge />} />
        <Route path="/post-detail/:id" element={<PostDetail/>} />
      </Routes>
    </Router>
  );
};

export default App;
